import { Typography } from '@mui/material';
import { forwardRef } from 'react';

const ReadOnly = forwardRef(
  ({ name, overwriteProps = {}, children, color = null, ...props }, ref) => {
    return (
      <Typography
        ref={ref}
        variant="subtitle2"
        color={color || 'tertiary.main'}
        component="span"
        sx={{ fontWeight: 500 }}
        {...props}
        {...overwriteProps}>
        {children || <div>&nbsp;</div>}
      </Typography>
    );
  },
);

export default ReadOnly;
